import { render } from "./TheCartOrderReceivingDelivery.vue?vue&type=template&id=6325dce8"
import script from "./TheCartOrderReceivingDelivery.vue?vue&type=script&lang=js"
export * from "./TheCartOrderReceivingDelivery.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__